module.exports = __webpack_public_path__ + "media/video.b06bc3ed.mp4";